import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { FormattedMessage } from 'react-intl';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import UserAvatarAndName from '../../components/user-avatar-and-name/';
import { emptyArray } from 'ui-components/default-props/empty';

import sharedStyle from './shared-classes.module.less';
import style from './assign-to-button.module.less';

export const INACTIVE_STATUS = 'Inactive';

const showUnassignedOption = (selectedIds, onAssign) => {
  return (
    <button className={style['unassigned-option']} onClick={() => onAssign(selectedIds, null)}>
      <div className={style['icon-wrap']}>
        <FontAwesomeIcon icon={faUser} />
      </div>
      <div>
        <FormattedMessage defaultMessage='(Nobody)' description='orderGridHeaderButtons.unassigned' id='cG3rDQ' />
      </div>
    </button>
  );
};

const DropdownToggler = (
  <DropdownMenuToggler theme='tertiary'>
    <FormattedMessage defaultMessage='Assign To' description='orderGridHeaderButtons.assign' id='u3nhqV' />
  </DropdownMenuToggler>
);

const AssignToButton = (props) => {
  const { users = emptyArray, isDisabled, onAssign = noop, selectedIds = emptyArray, supportsUnassignedOption = true } = props;

  return (
    <DropdownMenu className={sharedStyle['action-bar-button']} disabled={isDisabled} menuPosition='bottom-right'>
      {DropdownToggler}
      {supportsUnassignedOption && showUnassignedOption(selectedIds, onAssign)}
      {users.map(({ name, username, userId }, index) => {
        return (
          <DropdownMenuItem key={index} onClick={() => onAssign(selectedIds, userId)}>
            <UserAvatarAndName name={name} userName={username} />
          </DropdownMenuItem>
        );
      })}
    </DropdownMenu>
  );
};

AssignToButton.propTypes = {
  users: PropTypes.array,
  selectedIds: PropTypes.array,
  onAssign: PropTypes.func,
  supportsUnassignedOption: PropTypes.bool,
  isDisabled: PropTypes.bool.isRequired,
};

export default AssignToButton;
